import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/avimex/htdocs/avimex.co/app/components/Comments.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/avimex/htdocs/avimex.co/app/components/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/avimex/htdocs/avimex.co/app/components/SinglePostContent.js");
;
import(/* webpackMode: "eager" */ "/home/avimex/htdocs/avimex.co/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/avimex/htdocs/avimex.co/node_modules/next/dist/client/image-component.js");
